import type {PointsSkuListData} from './interface';
import {request} from '@/services';

const POINTS_SKU_ENDPOINTS = {
    /** 积分充值 SKU 列表 */
    SKU_POINTS: 'proxy-aicomic/sku/points',
} as const;

/** 获取积分充值 SKU 列表 */
export const getPointsSkuList = () =>
    request.get<PointsSkuListData>(POINTS_SKU_ENDPOINTS.SKU_POINTS);
